<template lang="pug">
    #assessment-exit-modal
      div.content-container
          p.has-text-centered.exit-modal-title Plan {{planStatus}}!
          p.exit-modal-subtitle Your daily plan has now been {{planStatus}}. Check back each day to access your new daily strategies and audio content to help support your mental wellbeing.
      .button-container
          WtButton.is-fullwidth.modal-exit-button.mb-1(color="primary" size="medium" @click.native="handleViewPlanClick") View plan
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile.vue";

export default {
  name: "CompanionPostAssessmentModal",
  components: {
    WtButton,
    WtTitle,
    WtTile
  },

  props: {
    onRedirect: {
      type: Function,
      required: true
    },
    planStatus: {
      type: String,
      default: "planCreated"
    }
  },

  data() {
    return {};
  },
  methods: {
    handleViewPlanClick() {
      this.onRedirect();
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
#assessment-exit-modal {
  display: flex !important;
  width: 566px !important;
  padding: var(--Spacing-xxxLarge, 32px) var(--Spacing-xxLarge, 24px)
    var(--Spacing-xxLarge, 24px) var(--Spacing-xxLarge, 24px) !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 34px !important;
  border-radius: 20px !important;
  background: #ffffff !important;
}

.exit-modal-title {
  font-size: 20px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
  letter-spacing: 0.15px !important;
}

.exit-modal-subtitle {
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  color: var(--Tool-Tip-Fill, #1b1d20) !important;
  text-align: center !important;
  font-style: normal !important;
}
.content-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 26px !important;
  align-self: stretch !important;
  display: flex;
}
.button-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 8px !important;
  align-self: stretch !important;
  margin: 0px !important;
}

.modal-exit-button {
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 20px !important;
}

@media screen and (max-width: 578px) {
  #assessment-exit-modal {
    max-width: 342px;
  }
}
</style>
